import { Injectable } from '@angular/core';
import { CreateMyPasswordContent } from '@com-delta-idp/mnx-login-ui';
import { LoginModalContent } from '../../models/aem';
import { ResetPasswordRequest } from '../../models/reset-password-api.interface';
import { CreateMyPasswordHelperService } from '../../services/create-my-password/create-my-password-helper.service';

@Injectable({
  providedIn: 'root'
})
export class CreateMyPasswordAdapter {
  constructor(private helper: CreateMyPasswordHelperService) {}

  getCreateMyPasswordContent(
    loginAemResponse: LoginModalContent
  ): CreateMyPasswordContent {
    return {
      formGroup: this.helper.createForm(),
      formAttributes: this.helper.getFormAttributes(),
      pageContent: this.helper.getCreateMyPasswordPageContent(loginAemResponse),
      showOverlayMessage: false,
      overlayMessage: ''
    };
  }

  setRequestObj(content: CreateMyPasswordContent): ResetPasswordRequest {
    const password =
      content.formGroup.controls['newPassword'].value.value.trim();
    return {
      tlMaskInfo_password: password,
      formNameSubmitted: content.pageContent.viewName
    };
  }
}
